"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCloudinaryUrl = exports.getCloudinarySource = undefined;

var _productLink = require("./product-link");

var getCloudinarySource = exports.getCloudinarySource = function getCloudinarySource(image) {
    if (!image || !image.cloudinaryId || !image.cloudinaryType) {
        return;
    }
    return {
        id: "v1/" + image.cloudinaryId,
        type: image.cloudinaryType
    };
};
var getCloudinaryUrl = exports.getCloudinaryUrl = function getCloudinaryUrl(image) {
    if (!image || !image.cloudinaryId || !image.cloudinaryType) {
        return;
    }
    var env = window.env || {};
    var CLOUDINARY_DOWNLOAD_URL = env.CLOUDINARY_DOWNLOAD_URL;
    var cloudinaryType = image.cloudinaryType,
        cloudinaryId = image.cloudinaryId;
    return (0, _productLink.stripMediaExtension)(CLOUDINARY_DOWNLOAD_URL + "/" + cloudinaryType + "/c_scale,h_800,q_auto:good/" + cloudinaryId) + ".jpg";
};
//# sourceMappingURL=image.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-ui/dist/order/views/pay-page/helpers/image.js
// module id = 1980
// module chunks = 0